import React, { useContext } from 'react';
import {
  Placeholder,
  ComponentRendering,
  ComponentParams,
  ComponentFactory,
  Field,
  SitecoreContext,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';

import './index.scss';
import { isLoggedIn } from '../../utils/authHelper';
import { Navigate } from 'react-router-dom';
import BackToTopButton from '../BackToTopButton/BackToTopButton';
import { APIWebstoreContext } from '../../context/globalContext';

export type CheckoutPageProps = WithSitecoreContextProps & {
  fields: {
    Heading: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

interface Props {
  children: React.ReactElement;
  componentFactory: ComponentFactory;
  rendering: ComponentRendering;
  params: ComponentParams;
}

const CheckoutPage = (props: Props): React.JSX.Element => {
  const { state } = useContext(APIWebstoreContext);

  return isLoggedIn() ? (
    state && state?.cartCounts?.totalCount && state?.cartCounts?.totalCount > 0 ? (
      <div className="checkout-page-main">
        <Placeholder name="page_checkoutdetails" rendering={props.rendering} />
        <Placeholder name="page_ordersummary" rendering={props.rendering} />
        <BackToTopButton />
      </div>
    ) : (
      <div className="checkout-empty-cart">
        <h1 className="cartPageTitle red-title">Your Cart is empty</h1>
        <h3>
          {(state?.sitecoreDictionaryData && state?.sitecoreDictionaryData?.EmptyCartMessage) ||
            'Looks like you have not added anything to your cart.'}
        </h3>
        <Placeholder name="continue_shopping" rendering={props.rendering} />
      </div>
    )
  ) : (
    <Navigate to="/checkout-login" />
  );
};

export default CheckoutPage;
